import { useState, useEffect, useRef } from "react";
import { useGetOrderByTCodeQuery } from "../store/api/orderAPI";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useGetOrderDeliveryQuery, useOrderDeliveryMutation } from "../store/api/orderSortApi";
import PresortDemo from "../components/table/DataTable";
import { orderColumn, orderColumnDelivery, orderColumnIssue } from "../metadata/order";
import { useTranslatedColumns } from "../hooks/useTranslatedColumns";

export default function ScanDelivery() {
    const [scanValue, setScanValue] = useState("");
    const [debouncedValue, setDebouncedValue] = useState(""); // <- для debounce
    const [scanList, setScanList] = useState([]);
    const { data } = useGetOrderDeliveryQuery();
    const [priemDelivery] = useOrderDeliveryMutation();
    const toast = useRef(null);
    const inputRef = useRef(null);
    const orderColumnTr = useTranslatedColumns(orderColumnDelivery);


    const { data: order } = useGetOrderByTCodeQuery(
        { tcode: debouncedValue, status: 22 },
        { skip: !debouncedValue }
    );

    useEffect(() => {
        if (order && Array.isArray(order) && order.length) {
            const scanned = order[0];

            if (scanList.some(item => item.tracking_number === scanned.tracking_number)) {
                toast.current.show({
                    severity: "warn",
                    summary: "Уже добавлено",
                    detail: `Заказ ${scanned.tracking_number} уже в списке`,
                    life: 2000,
                });
            } else {
                setScanList(prev => [scanned, ...prev]);
                toast.current.show({
                    severity: "success",
                    summary: "Добавлено",
                    detail: `Заказ ${scanned.tracking_number} найден`,
                    life: 2000,
                });
            }

            setScanValue(""); // очищаем input
            setDebouncedValue(""); // сбрасываем
            inputRef.current?.focus(); // автофокус обратно
        }
    }, [order]);

    const clearList = () => setScanValue([]);

    return (
        <div className="p-4">
            <Toast ref={toast} />


            <div style={{ display: "flex", gap: 14, alignItems: "center" }} className="mb-3">
                <h2 className="mb-3">Приём посылок (Сканирование)</h2>
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-qrcode" />
                    <InputText
                        ref={inputRef}
                        value={scanValue}
                        onChange={(e) => priemDelivery({ tracking_number: e.target.value })}
                        placeholder="Сканируйте штрих-код..."
                        style={{ paddingLeft: 40, height: 45 }}
                        autoFocus
                    />
                </IconField>

                <Button
                    style={{ height: 45, cursor: "pointer" }}
                    label="Очистить список"
                    className="p-button-danger mb-3"
                    onClick={clearList}
                // disabled={!scanList.length}
                />
            </div>

            <PresortDemo data={data?.result ?? []} paginator column={orderColumnTr}></PresortDemo>
        </div>
    );
}
